<template>
	<div class="gf-popup">
        <div class="inner-pop">
            <button @click="closeMe" class="close-btn">
                <span>Lukk skjema</span>
                <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <path fill="#005782" d="M14.9994,0 C6.728775,0 0,6.729 0,15 C0,23.271 6.728775,30 14.9994,30 C23.270475,30 30,23.271 30,15 C30,6.729 23.270475,0 14.9994,0 Z M14.9994,28.03275 C7.81335,28.03275 1.96725,22.1862 1.96725,15 C1.96725,7.813725 7.813275,1.967325 14.9994,1.967325 C22.18605,1.967325 28.0326,7.8138 28.0326,15 C28.0326,22.1862 22.18605,28.03275 14.9994,28.03275 Z"></path>
                    <path fill="#005782" d="M19.910475,10.089675 C19.52625,9.70545 18.903825,9.70545 18.5196,10.089675 L15,13.60905 L11.4804,10.089675 C11.096175,9.70545 10.4736,9.70545 10.089375,10.089675 C9.70515,10.473675 9.70515,11.096625 10.089375,11.480625 L13.608525,15 L10.088925,18.51945 C9.7047,18.903375 9.7047,19.5261 10.088925,19.910475 C10.281,20.102625 10.532775,20.198625 10.7844,20.198625 C11.036025,20.198625 11.287725,20.102625 11.479725,19.910475 L15,16.390725 L18.5196,19.910625 C18.71175,20.102775 18.9633,20.198775 19.214925,20.198775 C19.466475,20.198775 19.71825,20.10285 19.910325,19.910625 C20.29455,19.5267 20.29455,18.903675 19.910325,18.51975 L16.390875,15 L19.910475,11.480625 C20.2947,11.096625 20.2947,10.4739 19.910475,10.089675 Z" ></path>
                </svg>
            </button>
            <div class="content" >
                <h2 v-if="title" class="form-title" v-html="title"></h2>
                <div v-if="content" class="form-desc" v-html="content"></div>
                <div class="content-inner-form" ref="content" v-once>
                     <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: block;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <g transform="translate(80,50)">
                    <g transform="rotate(0)">
                    <circle cx="0" cy="0" r="6" fill="#93dbe9" fill-opacity="1" transform="scale(1.01682 1.01682)">
                    <animateTransform attributeName="transform" type="scale" begin="-0.875s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                    <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.875s"></animate>
                    </circle>
                    </g>
                    </g><g transform="translate(71.21320343559643,71.21320343559643)">
                    <g transform="rotate(45)">
                    <circle cx="0" cy="0" r="6" fill="#93dbe9" fill-opacity="0.875" transform="scale(1.07932 1.07932)">
                    <animateTransform attributeName="transform" type="scale" begin="-0.75s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                    <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.75s"></animate>
                    </circle>
                    </g>
                    </g><g transform="translate(50,80)">
                    <g transform="rotate(90)">
                    <circle cx="0" cy="0" r="6" fill="#93dbe9" fill-opacity="0.75" transform="scale(1.14182 1.14182)">
                    <animateTransform attributeName="transform" type="scale" begin="-0.625s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                    <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.625s"></animate>
                    </circle>
                    </g>
                    </g><g transform="translate(28.786796564403577,71.21320343559643)">
                    <g transform="rotate(135)">
                    <circle cx="0" cy="0" r="6" fill="#93dbe9" fill-opacity="0.625" transform="scale(1.20432 1.20432)">
                    <animateTransform attributeName="transform" type="scale" begin="-0.5s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                    <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.5s"></animate>
                    </circle>
                    </g>
                    </g><g transform="translate(20,50.00000000000001)">
                    <g transform="rotate(180)">
                    <circle cx="0" cy="0" r="6" fill="#93dbe9" fill-opacity="0.5" transform="scale(1.26682 1.26682)">
                    <animateTransform attributeName="transform" type="scale" begin="-0.375s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                    <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.375s"></animate>
                    </circle>
                    </g>
                    </g><g transform="translate(28.78679656440357,28.786796564403577)">
                    <g transform="rotate(225)">
                    <circle cx="0" cy="0" r="6" fill="#93dbe9" fill-opacity="0.375" transform="scale(1.32932 1.32932)">
                    <animateTransform attributeName="transform" type="scale" begin="-0.25s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                    <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.25s"></animate>
                    </circle>
                    </g>
                    </g><g transform="translate(49.99999999999999,20)">
                    <g transform="rotate(270)">
                    <circle cx="0" cy="0" r="6" fill="#93dbe9" fill-opacity="0.25" transform="scale(1.39182 1.39182)">
                    <animateTransform attributeName="transform" type="scale" begin="-0.125s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                    <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.125s"></animate>
                    </circle>
                    </g>
                    </g><g transform="translate(71.21320343559643,28.78679656440357)">
                    <g transform="rotate(315)">
                    <circle cx="0" cy="0" r="6" fill="#93dbe9" fill-opacity="0.125" transform="scale(1.45432 1.45432)">
                    <animateTransform attributeName="transform" type="scale" begin="0s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                    <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="0s"></animate>
                    </circle>
                    </g>
                    </g>
                    </svg>
                </div>
               
            </div>
        </div>
        <div class="overlay" @click="closeMe()"></div>
    </div>
</template>

<script>

export default {
    name: 'gravity-form-popup',
    props: {
        form: {
            type: Number,
            default: 1,
        },
        title: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
    },
    mounted(){
        document.getElementsByTagName('html')[0].classList.add('popup-open')
        const content = this.$refs.content;
        if(this.form && content){
            this.loadGravityForm2(this.form, content)
        }
    },
    destroyed(){
        document.getElementsByTagName('html')[0].classList.remove('popup-open')
    },
    methods:{
        closeMe(){
            this.$emit('close', true)
        },
        loadGravityForm2(formId, content){
            const apiUrl  = window.WPVUE.home.replace('/wp', '')+window.WPVUE.ajaxurl
            console.log(apiUrl)
			return window.axios.get(apiUrl, {
                params: {
                    action : 'gf_button_get_form',
                    form_id : formId
                }}).then(res => {

                    if ( typeof window['gformInitDatepicker'] !== 'undefined' ) {
                        window.gformInitDatepicker()
                    }
                    if(content) {
                        window.jQuery(content).html(res.data)
                    }
                    return res;
                })
        },
    },
    computed: {
        
    },
    
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.gf-popup{
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    .content-inner-form{
        .gform_heading{
            display: none;
        }    
    }
    .inner-pop{
        text-align: left;
        background: #FFFFFF;
        box-shadow: 0 0 20px 0 rgba(72,81,87,0.20);
        padding: 100px;
        position: relative;
        z-index: 20;
        max-width: 800px;
        width: 90%;
        max-height: 90%;
        overflow: auto;
        @include mquery($tablet){
            padding: 70px;
            width: 95%;
            max-height: 95%;
        }
        @include mquery($phone){
            padding: 50px 15px 30px;
        }

        .close-btn{
            cursor: pointer;
            background-color: transparent;
            position: absolute;
            top: 25px;
            right: 25px;
            z-index: 15; 
            border: none;
            display: flex;
            align-items: center;
            color: $darkLight;
            svg{
                margin-left: 15px;
            }
        }
    }
    .overlay{
        cursor: pointer;
        background-color: rgba(#fff, 0.5);
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 10;
    }
}
</style>
